import React from 'react';
import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import ConfiguracionAdmin from './Configuracion'; // Tu componente de formulario

const CompletarConfiguracion = ({ configuracion }) => {
  // Obtenemos el reporte en tiempo real
  const { completo, faltantes } = configuracion.actualizarSistema();

  return (
    <div className="min-h-screen w-full bg-gray-50 pb-20">
      {/* --- BANNER DE ALERTA (Header) --- */}
      <div className="sticky top-0 z-30 bg-white border-b border-red-200 shadow-md">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="bg-red-100 p-3 rounded-full">
                <AlertCircle className="text-red-600" size={28} />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Modo de Configuración Inicial</h1>
                <p className="text-sm text-gray-500">
                  El sistema está limitado hasta que se completen los campos obligatorios para 
                  <span className="font-bold text-blue-600"> {configuracion.nombreEmpresa || "la empresa"}</span>.
                </p>
              </div>
            </div>
            
            {/* Resumen rápido de faltantes */}
            <div className="flex items-center gap-2 bg-red-50 px-4 py-2 rounded-lg border border-red-100">
              <span className="text-red-700 font-bold text-lg">{faltantes.length}</span>
              <span className="text-red-600 text-xs uppercase font-black tracking-wider">Pendientes</span>
            </div>
          </div>

          {/* Lista de Checklist Horizontal (Scrolleable en móvil) */}
          <div className="mt-4 flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {faltantes.map((item, index) => (
              <span 
                key={index} 
                className="whitespace-nowrap flex items-center gap-2 bg-white border border-red-200 text-red-700 px-3 py-1.5 rounded-full text-xs font-semibold shadow-sm"
              >
                <div className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* --- CONTENIDO PRINCIPAL --- */}
      <div className="max-w-5xl mx-auto px-4 mt-8">
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-8 flex gap-3">
          <Info className="text-blue-500 shrink-0" size={20} />
          <p className="text-sm text-blue-800">
            <strong>Instrucciones:</strong> Utiliza el formulario de abajo para rellenar los datos. 
            Una vez guardes los cambios, el sistema validará automáticamente y te dará acceso al Dashboard completo.
          </p>
        </div>

        {/* Renderizamos el componente que realmente edita la base de datos */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
           <ConfiguracionAdmin />
        </div>
      </div>

      {/* Footer simple para dar contexto */}
      <div className="text-center mt-10 text-gray-400 text-xs">
        Plataforma Dufy • Sistema de Gestión de Configuración
      </div>
    </div>
  );
}

export default CompletarConfiguracion;